import { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { styled } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { Form } from './form';

interface Props {}

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-5);
`;

export const Solceller: FC<Props> = () => {
  const { t } = useTranslation();

  const energimerkeV2025Enabled = window.config.VITE_ENERGIMERKE_V2025_ENABLED;

  if (!energimerkeV2025Enabled) {
    return null;
  }

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('register.solar.header')}
      </Heading>
      <Paragraph>{t('register.solar.description')}</Paragraph>
      <Form />
    </PageWrapper>
  );
};
